import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Functions`}</p>
    <dl>
      <dt><a href="#useGiftOptions">useGiftOptions(props)</a> ⇒ <inlineCode><a href="#GiftOptionsTalonProps">GiftOptionsTalonProps</a></inlineCode></dt>
      <dd>
        <p>{`This talon contains the logic for a gift options component.
It performs effects and returns a data object containing values for rendering the component.`}</p>
        <p>{`This talon performs the following effects:`}</p>
        <ul>
          <li parentName="ul">{`Fetch the gift options associated with the cart`}</li>
          <li parentName="ul">{`Update the `}<a parentName="li" {...{
              "href": "#GiftOptionsTalonProps"
            }}>{`GiftOptionsTalonProps`}</a>{` values with the data returned by the query`}</li>
        </ul>
      </dd>
    </dl>
    <p>{`Typedefs`}</p>
    <dl>
      <dt><a href="#GiftOptionsTalonProps">GiftOptionsTalonProps</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Props data to use when rendering a gift options component.`}</p>
      </dd>
      <dt><a href="#GiftOptionsOperations">GiftOptionsOperations</a> : <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`This is a type used by the `}<a parentName="p" {...{
            "href": "#useGiftOptions"
          }}>{`useGiftOptions`}</a>{` talon.`}</p>
      </dd>
    </dl>
    <p>{`This talon contains the logic for a gift options component.
It performs effects and returns a data object containing values for rendering the component.`}</p>
    <p>{`This talon performs the following effects:`}</p>
    <ul>
      <li parentName="ul">{`Fetch the gift options associated with the cart`}</li>
      <li parentName="ul">{`Update the `}<a parentName="li" {...{
          "href": "#GiftOptionsTalonProps"
        }}>{`GiftOptionsTalonProps`}</a>{` values with the data returned by the query`}</li>
    </ul>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props.operations`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "#GiftOptionsOperations"
            }}><inlineCode parentName="a">{`GiftOptionsOperations`}</inlineCode></a></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{` `}<em parentName="p">{`(Importing into your project)`}</em>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { useGiftOptions } from '@magento/peregrine/lib/talons/CartPage/GiftOptions/useGiftOptions';
`}</code></pre>
    <p>{`Props data to use when rendering a gift options component.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`loading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Query loading indicator.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`errors`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Errors for GraphQl query and mutation.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`savingOptions`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Array containing fields that are busy.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`giftReceiptProps`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Props for the `}<inlineCode parentName="td">{`includeGiftReceipt`}</inlineCode>{` checkbox element.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`printedCardProps`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Props for the `}<inlineCode parentName="td">{`includePrintedCard`}</inlineCode>{` checkbox element.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`printedCardPrice`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Printed Card Price object.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`giftMessageCheckboxProps`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Props for the `}<inlineCode parentName="td">{`includeGiftMessage`}</inlineCode>{` checkbox element.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`giftMessageResult`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Object containing Gift Message data.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`hasGiftMessage`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Checks if Gift Message data has all fields filled.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`showGiftMessageResult`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Show or hide Gift Message result.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cardToProps`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Props for the `}<inlineCode parentName="td">{`cardTo`}</inlineCode>{` text input element.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cardFromProps`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Props for the `}<inlineCode parentName="td">{`cardFrom`}</inlineCode>{` text input element.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cardMessageProps`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Props for the `}<inlineCode parentName="td">{`cardMessage`}</inlineCode>{` textarea element.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`editGiftMessageButtonProps`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Props for the Edit Gift Message button.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`cancelGiftMessageButtonProps`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Props for the Cancel Gift Message button.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`saveGiftMessageButtonProps`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Props for the Update Gift Message button.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`optionsFormProps`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Props for the form element.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`This is a type used by the `}<a parentName="p" {...{
        "href": "#useGiftOptions"
      }}>{`useGiftOptions`}</a>{` talon.`}</p>
    <p><strong parentName="p">{`Properties`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`setGiftOptionsOnCartMutation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sets the gift options on cart.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`getGiftOptionsQuery`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`GraphQLAST`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`fetch the gift options.`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/peregrine/lib/talons/CartPage/PriceAdjustments/GiftOptions/useGiftOptions.js"
      }}>{`pwa-studio/packages/peregrine/lib/talons/CartPage/PriceAdjustments/GiftOptions/useGiftOptions.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      